// extracted by mini-css-extract-plugin
export default {"history":"Conversations_history__APvAo","section_summary":"Conversations_section_summary__xIc2X"};